<template>
  <div
    class="o-mobileHeader"
    :class="{
      '-homeHero': isHomeHero,
      '-withoutStickyHero': isHomeHero && !hasAskKeelearningModule,
    }"
    data-cy="MobileHeader">
    <router-link
      :to="{
        name: 'home',
      }">
      <img
        v-if="config.settings.app_logo"
        class="o-mobileHeader__logo"
        data-cy="MobileHeader__logo"
        :src="config.settings.app_logo"
        alt="app logo" />
    </router-link>
    <div class="u-spacer" />
    <div class="o-mobileHeader__actions">
      <ChatButton
        v-if="showChat"
        icon-only
        small-icon />
      <router-link
        v-if="avatar"
        :to="{
          name: 'profile.profile',
        }"
        class="o-mobileHeader__profileAvatar">
        <UserAvatar
          :avatar-url="avatar"
          :size="32"
          show-online-status
          data-cy="MobileHeader__avatar" />
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ChatButton from '@/modules/chat/components/ChatButton.vue'
import UserAvatar from '@/modules/frontendhome/components/UserAvatar.vue'

export default {
  props: {
    showChat: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isHomeHero() {
      return this.$route.name === 'learning-dashboard'
    },
    hasAskKeelearningModule() {
      return !!this.$store.getters['auth/hasModule'].ask_keelearning
    },
    ...mapGetters({
      avatar: 'auth/avatar',
      config: 'auth/config',
    }),
  },
  components: {
    ChatButton,
    UserAvatar,
  },
}
</script>
